import { indexTopics } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
            专题合集
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精选专题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按主题分类发现好剧，告别剧荒</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-auto">
          {indexTopics.slice(0, 7).map((item, i) => (
            <a
              key={item.title}
              href="#index"
              className={`group relative rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer ${
                i === 0 ? 'sm:col-span-2 sm:row-span-2' : ''
              } ${i === 1 ? 'sm:col-span-2' : ''}`}
            >
              <div className={`relative w-full ${i === 0 ? 'aspect-[16/9]' : i === 1 ? 'aspect-[16/7]' : 'aspect-[4/3]'} overflow-hidden`}>
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-sm md:text-base font-semibold text-background-50">{item.title}</h3>
                  <p className="text-xs text-background-50/70 mt-1">{item.count} 部剧集</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}